module.exports = __webpack_public_path__ + "img/oversea.9bde2fdf.png";